import React, {useContext, useEffect} from "react";

// react-router-dom components
import {useLocation} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "../../components/MDBox";

// Material Dashboard 2 PRO React context
import {setLayout, useMaterialUIController} from "../../context";
import {CompanyContext} from "../../lib/CompanyProvider";

function CustomerPageLayout({background = "default", children}) {
  const [controller, dispatch] = useMaterialUIController();
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const {pathname} = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <MDBox
      sx={({breakpoints, transitions, functions: {pxToRem}}) => ({
        paddingBottom: '50px',
        minHeight: '100vh',
        position: "relative",

        [breakpoints.up("xl")]: {
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {companyContext && <>
        {companyContext?.subdomain && companyContext?.company?.portalHeader && <>
          <div dangerouslySetInnerHTML={{__html: '<div>' + companyContext?.company?.portalHeader}}/>
        </>}
        <div className="psb-content-outer">
          <div className="psb-content">
            {children}
          </div>
        </div>
        {companyContext?.subdomain && companyContext?.company?.portalFooter && <>
          <div dangerouslySetInnerHTML={{__html: companyContext?.company?.portalFooter + '</div>'}}/>
        </>}
      </>}

    </MDBox>
  );
}

// Typechecking props for the PageLayout
CustomerPageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default CustomerPageLayout;
